import { render, staticRenderFns } from "./discoverList.vue?vue&type=template&id=0be41ee4&"
import script from "./discoverList.vue?vue&type=script&lang=js&"
export * from "./discoverList.vue?vue&type=script&lang=js&"
import style0 from "./discoverList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports